<template>
  <component
    :is="as"
    :class="['align', { collapse, 'collapse-end': collapseEnd, flex, 'small-gap': smallGap, 'no-gap': noGap, wrap }]"
    :style="{ 'align-items': direction, 'justify-content': justify }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    as: {
      type: String,
      default: 'div',
    },
    collapse: Boolean,
    collapseEnd: Boolean,
    flex: Boolean,
    smallGap: Boolean,
    noGap: Boolean,
    wrap: Boolean,
    direction: {
      type: String,
      default: 'center',
    },
    justify: {
      type: String,
      default: 'flex-start',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/variables.scss';

.align {
  display: flex;

  > *:not(:last-child) {
    margin-right: $gp;
  }

  &.flex {
    > :first-child {
      flex: 1;
    }
  }

  &.wrap {
    flex-wrap: wrap;
  }

  &.small-gap {
    > *:not(:last-child) {
      margin-right: $gp * .5;
    }
  }

  &.no-gap {
    > *:not(:last-child) {
      margin-right: 0;
    }
  }

  @media($medium-down) {
    &.collapse,
    &.collapse-end {
      flex-direction: column;
      align-items: flex-start;

      > *:not(:last-child) {
        margin-right: 0;
        margin-bottom: $gp;
      }

      &.small-gap {
        > *:not(:last-child) {
          margin-bottom: $gp * .5;
        }
      }
    }

    &.collapse-end {
      > *:last-child {
        align-self: flex-end;
      }
    }
  }
}
</style>
